import dayjs from 'dayjs'
import {
    generateId,
    getNameAndExtensionFromFileName,
    log,
    parseAwsS3Error,
    removeSpecialChars,
} from '../helpers/utils'
import { nextAPI } from './Axios'
import axios from 'axios'

export const FileAPI = {
    async upload(file) {
        const today = dayjs().format('YYYY-MM-DD')
        const random = generateId()

        const albumName = file?.folder || today
        const originalFileName = file?.displayName || file.name

        let [fileName, fileExtension] =
            getNameAndExtensionFromFileName(originalFileName)

        // fileName = fileName || `${originalFileName}`
        // const Identifier = `#${order.id}-${random}`

        // this fixes download url issues
        fileName = removeSpecialChars(fileName)

        const storePrefix = process.env.NEXT_PUBLIC_STORE_SUFFIX
        const prefix = storePrefix === 'main' ? '' : `${storePrefix}`

        // const Identifier = `${prefix}${order.id}`
        const Identifier = `${prefix}`
        const randomString = `_${random}`

        let keyName
        if (file.name.includes('rewritingFile')) {
            fileName = fileName.replace('rewritingFile', '')
            fileName = fileName.replace('-/', '')
            keyName = `${fileName}${fileExtension}`
            log('includes(rewritingFile)', keyName)
        } else {
            keyName = `${albumName}/${Identifier}-${fileName}${randomString}${fileExtension}`
        }

        // const fileType = file.type
        // const fileSize = file.size

        try {
            const { data: uploadURL } = await nextAPI.post('upload-file', {
                Key: keyName,
            })

            await axios.put(uploadURL, file, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

            return uploadURL.split('?')[0]
        } catch (e) {
            console.log('File upload Error', e.response)
            const { code, message } = parseAwsS3Error(e.response.data)
            throw Error(`Error in File Upload.
                code: ${code}
                message: ${message}
            `)
        }
    },

    async uploadFiles(files, order) {
        if (!Array.isArray(files)) return await this.upload(files, order)

        return Promise.all(
            files.map(async (file) => {
                const uploadedFile = await this.upload(file, order)
                return {
                    name: file.name,
                    url: uploadedFile,
                }
            }),
        )
    },

    async deleteCustomUpload(url) {
        return await nextAPI.post('delete-custom-upload', {
            fileUrl: url,
        })
    },
}
